import { render, staticRenderFns } from "./distributionClient.vue?vue&type=template&id=2b49891e&scoped=true"
import script from "./distributionClient.vue?vue&type=script&lang=js"
export * from "./distributionClient.vue?vue&type=script&lang=js"
import style0 from "./distributionClient.vue?vue&type=style&index=0&id=2b49891e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b49891e",
  null
  
)

export default component.exports